<template>
  <div id="app" v-bind:class="pdsVariant" v-bind:style="backgroundImage">
    <div
      class="content pds-s-content"
      v-bind:style="{ backgroundColor: contentBackgroundColor }"
    >
      <router-view></router-view>
    </div>
    <footer class="footer">
      <a href="/" class="pds-c-logo" title="Home">
        <figure>
          <svg
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="205px"
            height="74px"
            aria-hidden="true"
            role="img"
          >
            <use
              xlink:href="assets/styling/pds/images/brand/logo.svg#root"
            ></use>
          </svg>
        </figure>
      </a>
    </footer>
  </div>
</template>

<script>
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const Home = () =>
  import(/* webpackChunkName: "survey" */ "./views/Survey.vue");
const Result = () =>
  import(/* webpackChunkName: "result" */ "./views/Result.vue");
const CompareResults = () =>
  import(/* webpackChunkName: "compareResults" */ "./views/CompareResults.vue");

const router = new VueRouter({
  routes: [
    { path: "/", component: Home },
    { path: "/result", component: Result },
    { path: "/compare", component: CompareResults }
  ],
});

export default {
  name: "app",
  router: router,
  computed: {
    backgroundImage() {
      // 500 is min-width of the content
      if (window.innerWidth <= 500) return false;
      return {
        backgroundImage: `url(assets/images/${this.$store.state.config.backgroundImage})`,
      };
    },
    contentBackgroundColor() {
      return this.$store.state.config.contentBackgroundColor;
    },
    pdsVariant() {
      return `pds-t-${this.$store.state.config.pdsVariant}`;
    },
  },
};
</script>

<style>
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background-size: cover;
}

.content {
  flex: 1 0 auto;
  margin-left: auto;
  margin-right: auto;
  padding-top: 25px;
  padding-bottom: 45px;
  background-color: #fff;
}

.footer {
  flex-shrink: 0;
  background-color: #F20E43;
}

.footer .pds-c-logo {
  color: rgba(0, 0, 0, 0);
}

* {
  box-sizing: border-box;
}

@media only screen and (min-width: 768px) {
  .content {
    padding: 2em;
    width: 50%;
    min-width: 500px;
    max-width: 875px;
    margin: 0 auto;
  }
}

</style>
